import { EChartsOption } from "echarts";
import { useMemo } from "react";

const useEChartsOption = (callback: () => EChartsOption, deps: any[]) => {
  const option = useMemo<EChartsOption>(callback, deps);
  return option;
};

export { useEChartsOption };
